import { type PropsWithChildren, useContext } from 'react';

import './CustomerLeadStepLayout.scss';

import LogoText from 'src/assets/logo-text.svg?react';
import { CustomerLeadGuideMobile } from 'src/components/customers/steps/CustomerLeadGuideMobile';
import { CustomerLeadStepGuide } from 'src/components/customers/steps/CustomerLeadStepGuide';
import { CustomerLeadStepLayoutBackButton } from 'src/components/customers/steps/CustomerLeadStepLayoutBackButton';
import { CustomerLeadStepLayoutNextButton } from 'src/components/customers/steps/CustomerLeadStepLayoutNextButton';
import { CustomerLeadStepper } from 'src/components/customers/steps/CustomerLeadStepper';
import { CustomersContext } from 'src/pages/CustomersPage/CustomersPage.context';
import { CustomerPageStep } from 'src/pages/CustomersPage/CustomersPage.context.types';

export function CustomerLeadStepLayout({ children }: Readonly<PropsWithChildren>) {
  const { customerStep } = useContext(CustomersContext);

  const canGoBack = customerStep !== CustomerPageStep.Quantities; // Ignore CustomerPageStep.Start
  const canGoNext =
    customerStep === CustomerPageStep.ProductSpecifications || customerStep === CustomerPageStep.AdditionalInformation;

  return (
    <div className="customer-lead-step__layout">
      <div className="customer-lead-step__layout__left" />

      <div className="customer-lead-step__layout__center__header__backdrop" />
      <div className="customer-lead-step__layout__center__header__container">
        <div className="customer-lead-step__layout__center__header">
          <div className="customer-lead-step__layout__center__header__left-buttons">
            {canGoBack && <CustomerLeadStepLayoutBackButton />}
          </div>

          <div className="customer-lead-step__layout__center__header__logo">
            <LogoText className="customer-lead-step__layout__center__header__logo-text" />
            <div className="customer-lead-step__layout__center__header__logo-icon" />
          </div>

          <div className="customer-lead-step__layout__center__header__right-buttons">
            <CustomerLeadGuideMobile />
          </div>
        </div>

        <div className="customer-lead-step__layout__center__stepper">
          <CustomerLeadStepper />
        </div>
      </div>

      <div className="customer-lead-step__layout__center">
        <div className="customer-lead-step__layout__center__content">{children}</div>

        {canGoNext && (
          <div className="customer-lead-step__layout__center__footer-actions">
            <CustomerLeadStepLayoutNextButton />
          </div>
        )}
      </div>
      <div className="customer-lead-step__layout__right">
        <CustomerLeadStepGuide />
      </div>
    </div>
  );
}
